/** Text primitive editor (also the graceful fallback for number/date/boolean). */
import type { ProposalFieldEditorProps } from "../ProposalEditor.js";
import { controlStyle, fieldDomId } from "../ProposalEditor.js";

export function TextField({ field, value, onChange, idPrefix }: ProposalFieldEditorProps) {
  return (
    <input
      id={fieldDomId(idPrefix, field.key)}
      type="text"
      aria-label={field.label}
      style={controlStyle}
      value={value == null ? "" : String(value)}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
